export default __webpack_public_path__ + "static/media/highlight_off.9910cffb.svg";